import { Col, Grid, Layout, Row, Space } from "antd";
import BodyContentComponent from "components/reusables/BodyContent/BodyContentComponent";
import React from "react";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import Icon from "@ant-design/icons";
import transferenceIcon from "../../../assets/namespace/icons/tfrIcon";
import InfoCardComponent from "components/reusables/InfoCard/InfoCardComponent";
import InitialFormComponent from "components/reusables/InitialForm/InitialFormComponent";
import imgTrfExpress from "../../../assets/namespace/logos/autofact_transferencia_express.svg";
import {
  ItemSimpleCheckList,
  SimpleCheckListComponentTypes
} from "../../reusables/SimpleCheckList/SimpleCheckListComponent.types";
import SimpleCheckListComponent from "../../reusables/SimpleCheckList/SimpleCheckListComponent";
import './BodyContainer.scss'

const { useBreakpoint } = Grid;
const { Header, Footer, Sider, Content } = Layout;

const TfrIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={transferenceIcon} {...props} />
);

const FirstStepArrayList: Array<ItemSimpleCheckList> = [
  {
    id: 'first',
    text: 'Revisa el paso a paso a modo de ejemplo y aclara tus dudas',
    type: 'check'
  },
  {
    id: 'second',
    text: 'Conoce los documentos necesarios para el trámite y calcula tu transferencia',
    type: 'check'
  },
  {
    id: 'thirty',
    text: 'Te regalamos un descuento al final del recorrido',
    type: 'check'
  },
]

const SimpleCheckListProps: SimpleCheckListComponentTypes = {
  ArrayItemsSimpleCheck: FirstStepArrayList,
  className: 'default'
}



function BodyContainer() {
  const screens = useBreakpoint();
  return (
    <div className={"BodyContainer"}>
      <div className={'content-container'}>
        <BodyContentComponent
          icon={<TfrIcon style={{ fontSize: `${!screens["md"] ? '31.9px' : '39.9px'}` }} />}
          bodyHeaderText="Te damos la bienvenida al simulador de Transferencia de vehículos"
          bodyText={<SimpleCheckListComponent {...SimpleCheckListProps} />}
        />
      </div>
      <div className={'form-container'}>
        <InfoCardComponent
          text={"Necesitamos tus datos para comenzar"}
          type={"cardInfo"}
          number={"1"}
        />
        <div style={{marginTop: '24px'}}>
          <InitialFormComponent alert={true} />
        </div>
      </div>
      <div className={'img-container'}>
        <img src={imgTrfExpress}
             alt="Transferencia Online, Autofact"
        />
      </div>
    </div>
  );
}

export default BodyContainer;
